export default function ({ route, redirect }) {
	const path = route.fullPath;

	// If already encoded, do nothing
	if (path.includes("[") || path.includes("]")) {
		const encodedPath = path.replace(/\[/g, "%5B").replace(/\]/g, "%5D");

		if (encodedPath !== path) {
			return redirect(encodedPath);
		}
	}
}
